const StaffExitIcon = (color: any) => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
      >
        <g clipPath="url(#clip0_3016_14437)">
          <path
            d="M52 64H12C5.372 64 0 58.628 0 52V12C0 5.372 5.372 0 12 0H52C58.628 0 64 5.372 64 12V52C64 58.628 58.628 64 52 64Z"
            fill={color.color}
          />
          <path
            d="M28 30.332C31.6815 30.332 34.666 27.3475 34.666 23.666C34.666 19.9845 31.6815 17 28 17C24.3185 17 21.334 19.9845 21.334 23.666C21.334 27.3475 24.3185 30.332 28 30.332Z"
            fill="#183883"
          />
          <path
            d="M33.666 33H22.332C18.842 33 16 35.842 16 39.334V44C16 44.552 16.448 45 17 45H39C39.552 45 40 44.552 40 44V39.334C40 35.842 37.158 33 33.666 33Z"
            fill="#183883"
          />
          <path
            d="M47.682 28.2641L43.016 23.9301C42.828 23.7541 42.584 23.6641 42.336 23.6641C41.676 23.6641 41.336 24.2261 41.336 24.6621V27.6621H36C35.264 27.6621 34.666 28.2601 34.666 28.9961C34.666 29.7321 35.262 30.3301 36 30.3301H41.334V33.3301C41.334 33.8841 41.784 34.3301 42.334 34.3301C42.582 34.3301 42.826 34.2381 43.014 34.0641L47.68 29.7301C47.884 29.5421 48 29.2761 48 28.9981C48 28.7201 47.884 28.4541 47.682 28.2641Z"
            fill="#F12A00"
          />
        </g>
        <defs>
          <clipPath id="clip0_3016_14437">
            <rect width="64" height="64" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};
export default StaffExitIcon;
